import React, { useEffect, useRef, useState } from "react";
import { HiOutlineArrowsExpand } from "react-icons/hi";
import Carousel from "react-multi-carousel";
import { useSelector } from "react-redux";
import { Box, Flex } from "rebass";
import Tooltip from "../../components/common/Tooltip";
import Close from "../../icons/Close";
import I360 from "../../icons/I360";
import { getLocalizedString } from "../../utils";
import { PopupItem } from "../cart/PopupItem";
import { ColorTooltip } from "../common/ColorTooltip";
import Expand360 from "./Expand360";
import ExpandImage from "./ExpandImage";
const PopupImages = ({
  id = null,
  product = null,
  open = false,
  close = null,
  data = [],
  style,
  imageDefault,
  rotationdefault,
  type,
  colorComponentName = "catalogueGrillReorderSwapAndPopup",
}) => {
  const lang = localStorage.getItem("B2BLanguage") == "ITA" ? "it" : "en";

  const { colors } = useSelector((state) => state.yodaIdentity);
  const [images, setImages] = useState([]);
  const [colorMap, setColorMap] = useState({});
  const [dataMap, setDataMap] = useState([]);
  const [images360, setImages360] = useState([]);
  const [existImage, setExistImage] = useState(true);
  const [fallbackImage, setFallbackImage] = useState(false);
  const [expandImage, setExpandImage] = useState(false);
  const [expand360, setExpand360] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);

  const carouselRef = useRef();

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    resetImages();
  }, [data, open]);

  const resetImages = () => {
    setSelectedColor(null);
    if (data && data.length > 0) {
      let tmpColorMap = {};
      let tmpImages = [];
      data
        .sort((a, b) => a.colorCode.localeCompare(b.colorCode))
        .forEach((e) => {
          if (e.images) {
            tmpColorMap[e.colorCode] = e.images;

            //if there's an image with type "Preview", remove the default image (assuming they're equal)
            if (
              tmpColorMap[e.colorCode]?.find(
                (i) => i["type"].toUpperCase() === "PREVIEW",
              )
            ) {
              tmpColorMap[e.colorCode] = tmpColorMap[e.colorCode].filter(
                (img) => img.link !== imageDefault,
              );
            }
            if (e.images.length > 0) {
              e.images.forEach(
                (img) =>
                  !tmpImages.find((i) => i.link === img.link) &&
                  tmpImages.push(img),
              );
            }
          }
        });
      if (tmpImages?.find((i) => i["type"].toUpperCase() === "PREVIEW")) {
        tmpImages = tmpImages.filter((img) => img.link !== imageDefault);
      }
      setColorMap(tmpColorMap);
      setImages(tmpImages);
      if (currentImage === null) {
        setCurrentImage(tmpImages[0]);
      }

      let tmpDataMap = {};
      let tmpData = [];
      data.forEach((e) => {
        if (!tmpDataMap[e.catalogId]) {
          tmpDataMap[e.catalogId] = 1;
          tmpData.push(e);
          const item360Images =
            e?.images?.filter?.((image) => image?.type === "360") ?? [];
          setImages360((images) => [...images, ...item360Images]);
        }
      });

      setDataMap(tmpData);
    } else {
      setFallbackImage(true);
      setExistImage(false);
    }
  };

  function changeImage(code) {
    if (code !== selectedColor) {
      setImages(colorMap[code]);
      setSelectedColor(code);
      carouselRef.current.state.currentSlide = 0;
    } else {
      resetImages();
    }
  }

  const image360 = () => {
    const link360 =
      typeof rotationdefault === "string"
        ? rotationdefault
        : images?.find?.((i) => i.type == "360")?.link || images360?.[0]?.link;

    if (!link360) return null;

    return (
      <Tooltip content={getLocalizedString("GALLERY_360_TOOLTIP")}>
        <Box onClick={() => setExpand360(link360)}>
          {/* <a href={link360} target="_blank" rel="noreferrer"> */}
          <I360
            style={{
              height: 24,
              color: "#A2A2A2",
              marginLeft: 10,
            }}
          />
          {/* </a> */}
        </Box>
      </Tooltip>
    );
  };

  return (
    <Box
      style={{
        backgroundColor: "rgba(0,0,0,.85)",
        zIndex: 9997,
        display: open ? "flex" : "none",
      }}
      className="modal"
      onClick={(e) => {
        if (e.target.classList && e.target.classList[0] == "modal") {
          close();
        }
      }}
    >
      <Box
        className="modal-content"
        sx={{
          width: ["100vw", 600],
          height: ["100dvh", 500],
          position: "relative",
          margin: "0 auto",
        }}
        style={{
          ...style,
        }}
      >
        {
          //<iframe style={{...style, position: "absolute"}} src={"https://d35cat4w6cwz4j.cloudfront.net/BRIDGE/index.htm?type=HILP&viewer=CDB0379A-D1CD-4C12-B00A-339580ABDAED/CDB0379A-D1CD-4C12-B00A-339580ABDAED&width=600&height=600&autoRotation=true&allowRotation=true&resetOnMouseout=false&hasButtons=true&fullScreen=true"}></iframe>
        }
        <Box
          sx={{ "& > svg > g > g > line": { stroke: "white" } }}
          style={{
            cursor: "pointer",
            position: "absolute",
            top: "15px",
            right: "15px",
            width: "24px",
            backgroundColor: "#232323",
          }}
          onClick={(evt) => {
            close();
            evt.preventDefault();
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
          }}
        >
          <Close style={{ width: 24, height: 24 }}></Close>
        </Box>
        <Flex
          flexDirection={["column-reverse", "row"]}
          alignItems={"flex-start"}
          sx={{
            height: "100%",
            overflowY: ["hidden", "unset"],
          }}
          p={1}
        >
          <Flex
            sx={{
              height: ["auto", "100%"],
              flex: [1, "unset"],
              width: ["100%", "calc(100% * (2 / 3))"],
              position: "relative",
              backgroundColor: "#fff",
            }}
          >
            <Flex
              style={{
                position: "absolute",
                color: "#A2A2A2",
                marginLeft: 10,
                marginTop: 12,
                left: 10,
                cursor: "pointer",
                zIndex: 9998,
              }}
              alignItems={"center"}
            >
              <Tooltip content={getLocalizedString("GALLERY_EXPAND_TOOLTIP")}>
                <Flex
                  alignItems={"center"}
                  onClick={() => setExpandImage(true)}
                >
                  <HiOutlineArrowsExpand
                    style={{
                      width: "20px",
                      height: "auto",
                    }}
                  />
                </Flex>
              </Tooltip>
              {image360()}
            </Flex>

            {expandImage && (
              <ExpandImage
                imgs={[currentImage?.link || imageDefault]}
                onClose={() => setExpandImage(false)}
              />
            )}

            {expand360 && (
              <Expand360 src={expand360} onClose={() => setExpand360(null)} />
            )}

            {existImage && images && images.filter && !fallbackImage && (
              <Carousel
                ref={carouselRef}
                responsive={responsive}
                style={{
                  backgroundColor: "#ff9900",
                }}
                afterChange={(_previousSlide, { currentSlide }) => {
                  setCurrentImage(images[currentSlide]);
                }}
              >
                {existImage &&
                  images &&
                  images.filter &&
                  !fallbackImage &&
                  images.filter((i) => i.type != "360").length > 0 &&
                  images
                    .filter((i) => i.type != "360")
                    ?.map((i, idx) => {
                      return (
                        <PopupItem
                          style={{
                            marginRight: 2,
                            marginLeft: 4,
                            padding: "10px",
                            position: "relative",
                          }}
                          image={i.link}
                          key={idx}
                        ></PopupItem>
                      );
                    })}
              </Carousel>
            )}
            {fallbackImage && (
              <Carousel
                ref={carouselRef}
                responsive={responsive}
                style={{
                  backgroundColor: "#ff9900",
                }}
              >
                {fallbackImage && (
                  <PopupItem
                    style={{
                      marginRight: 2,
                      marginLeft: 4,
                      padding: "10px",
                      position: "relative",
                    }}
                    image={imageDefault}
                  ></PopupItem>
                )}
              </Carousel>
            )}
            {/* {!!selectedColor && !fallbackImage && <Flex
                            style={{
                                position: "absolute",
                                color: "#A2A2A2",
                                right: 12,
                                bottom: 12,
                                zIndex: 9998,
                                fontSize: "20px"
                            }}
                            alignItems={'center'}
                        >
                            {selectedColor}
                        </Flex>} */}
          </Flex>
          <Flex
            sx={{
              width: ["100%", "calc(100% / 3)"],
              height: ["auto", "100%"],
              marginTop: "30px",
              overflowX: ["hidden", "unset"],
              paddingLeft: ["0", "15px"],
            }}
            flexDirection="column"
            justifyContent="flex-start"
          >
            <Flex
              sx={{
                fontSize: "0.8em",
                fontWeigth: 800,
                paddingLeft: "10px",
                background: "#F2F2F2",
                width: "100%",
              }}
            >
              {getLocalizedString("COLORS AVAILABILITY")}
            </Flex>

            <Flex
              width="100%"
              flexWrap={["nowrap", "wrap"]}
              justifyContent={"left"}
              sx={{
                overflowX: ["auto", "unset"],
                paddingTop: ["5px", "0"],
              }}
              mt={2}
            >
              {colors &&
                colors.length > 0 &&
                dataMap &&
                dataMap.map((e, i) => {
                  let c = colors.find((c) => c.code == e.colorCode);
                  if (c) {
                    return (
                      <Box
                        sx={{
                          width: ["auto", "50%"],
                          maxWidth: ["100px", "unset"],
                          marginBottom: ["20px", "7px"],
                          position: "relative",
                          flex: ["1 0 30%", "unset"],
                        }}
                        onClick={() => {
                          changeImage(e.colorCode || e.code);
                        }}
                        key={i}
                      >
                        <ColorTooltip
                          id={id}
                          code={e.colorCode}
                          colorDescription={c.description[lang]}
                          rgb={c.rgb}
                          componentName={colorComponentName}
                          isSelected={
                            e?.colorCode === selectedColor ||
                            c?.code === selectedColor
                          }
                          {...{ type }}
                        ></ColorTooltip>
                      </Box>
                    );
                  }
                })}
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export { PopupImages };
